<div class="tab-inner-content">
  <h2>Account Ledger Report</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <h5>
    Account Name : {{accountLedgerReport?.accountName}}
  </h5>
  <table>
    <thead>
      <tr>
        <th>Date</th>
        <th>Reference#</th>
        <th>Debit</th>
        <th>Credit</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of accountLedgerReport?.transactions">
        <tr class="child">
          <td>{{ item?.date | date : "MM/d/YYYY" }}</td>
          <td>{{ item?.reference ?  item?.reference : '--' }}</td>
          <td>{{ item?.debit | number : "1.2-2" }}</td>
          <td>{{ item?.credit  | number : "1.2-2" }}</td>
        </tr>
      </ng-container>
      <tr *ngIf="accountLedgerReport" class="title">
        <td>Total Debit</td>
        <td></td>
        <td>{{ accountLedgerReport?.totalDebit | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="accountLedgerReport" class="title">
        <td>Total Credit</td>
        <td></td>
        <td></td>
        <td>{{ accountLedgerReport?.totalCredit | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="!accountLedgerReport">
        <td colspan="4" class="no-data">
          No data available
        </td>
      </tr>

    </tbody>
  </table>
</div>